import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';
import { FONT, FONT_BOLD, FONT_SIZE_NORMAL, FONT_SIZE_SMALL, SPACE } from '../variables';
import { cmToPoint } from './units';

export function renderDetails(pdf: PDFDocument, body: any) {
	if (!body.details?.length) {
		return;
	}

	const textHeightFix = 15;
	const labelHeightFix = 2;
	const space = cmToPoint(SPACE);
	const maxWidth = pdf.page.width - pdf.page.margins.left - pdf.page.margins.right;

	pdf.y += cmToPoint(SPACE + 0.03);

	pdf.font(FONT);

	const textOptions = {
		height: 11,
		ellipsis: '...'
	};

	const items: [][] = [];

	if (body.details.length > 2) {
		while (body.details.length > 0) {
			items.push(body.details.splice(0, 2));
		}
	} else {
		while (body.details.length > 0) {
			items.push(body.details.splice(0, 1));
		}
	}

	const resetX = pdf.x;
	let resetY = 0;

	items.forEach((group, i) => {
		const colWidth = (maxWidth / 3) * i;

		let width = 0;
		group.forEach((item: any) => {
			pdf.fontSize(FONT_SIZE_SMALL);
			width = Math.max(pdf.widthOfString(item.label, textOptions), width);
		});

		group.forEach((item: any, y) => {
			const colHeight = y === 0 ? 0 : space + textHeightFix;

			const startX = pdf.x;
			const startY = pdf.y;

			pdf.x = startX + colWidth;
			pdf.y = startY + colHeight;

			if (item.bold) {
				pdf.font(FONT_BOLD);
			} else {
				pdf.font(FONT);
			}

			pdf.fontSize(FONT_SIZE_SMALL);
			pdf.text(item.label, textOptions);

			pdf.y += labelHeightFix;

			pdf.fontSize(FONT_SIZE_NORMAL);
			pdf.text(item.value, textOptions);

			resetY = Math.max(pdf.y, resetY);

			pdf.x = startX;
			pdf.y = startY;
		});
	});

	pdf.x = resetX;
	pdf.y = resetY;
}
